import React from 'react';
import PropTypes from 'prop-types';
import {SortableContainer} from 'react-sortable-hoc';

import SortableItem from './item';

const isRocket = process.env.CPA_ENV === 'rocket';

const Sortable = SortableContainer((props) => {
	return (
		<div className="fields-wrap__list">
			{props.fields.map((parentName, index, fields) => (
				<SortableItem {...props}
					key={index}
					parentName={parentName}
					index={index}
					originalIndex={index}
					fields={fields}/>
			))}
		</div>
	);
});

const SortableWrap = props => {
	return (
		<div className="fields-wrap">
			{!isRocket && (
				<div className="is_restricted_title">is restricted</div>
			)}
			<div className="default_geo">Default geo</div>
			{ process.env.CPA_ENV === 'everad' && <div className="is_mgid"> MGID </div> }
			<Sortable {...props} />

			{ props.can('edit') && (
				<div className="fields-wrap__add" onClick={() => !props.shouldTranslate && props.fields.push({})}>
					<span className="fields-wrap__add-title">{props.title}</span>
				</div>
			)}
		</div>
	);
};

SortableWrap.propTypes = {
	can: PropTypes.func,
	shouldTranslate: PropTypes.bool,
	fields: PropTypes.object,
	title: PropTypes.string
};

export default SortableWrap;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/landings/sortable/container.js